// Module
var code = `<div class="compliance-config-redflag-section">
  <ng-form name="\$ctrl.form">
    <div class="compliance-config-redflag-section__column compliance-config-redflag-section__padding">
      <form-section form-title="'Unusual transactions'">
        <form-section-field field-title="'Transaction amount ceiling'">
          <cash ng-model="\$ctrl.complianceConfig.unusualTransactionAmountThreshold" min="1" required="true">
          </cash>
        </form-section-field>
      </form-section>
      <form-section form-title="'Daily transaction count threshold'">
        <form-section-field field-title="'Individual customer'">
          <input
            type="number"
            ng-model="\$ctrl.complianceConfig.individualDailyMultipleTransactionThreshold"
            min="1"
            required/>
        </form-section-field>
        <form-section-field field-title="'Individual with BDA customer'">
          <input
            type="number"
            ng-model="\$ctrl.complianceConfig.bdaDailyMultipleTransactionThreshold"
            min="1"
            required/>
        </form-section-field>
        <form-section-field field-title="'Individual restricted customer'">
          <input
            type="number"
            ng-model="\$ctrl.complianceConfig.restrictedDailyMultipleTransactionThreshold"
            min="1"
            required/>
        </form-section-field>
        <form-section-field field-title="'Corporate customer'">
          <input
            type="number"
            ng-model="\$ctrl.complianceConfig.corporateDailyMultipleTransactionThreshold"
            min="1"
            required/>
        </form-section-field>
      </form-section>
      <form-section form-title="'Short term account'">
        <form-section-field field-title="'Account: No. of days'">
          <input
            type="number"
            ng-model="\$ctrl.complianceConfig.shortTermAccountThreshold"
            min="0"
            required/>
        </form-section-field>
        <form-section-field field-title="'Deposit: No. of days'">
          <input
            type="number"
            ng-model="\$ctrl.complianceConfig.shortTermDepositThreshold"
            min="0"
            required/>
        </form-section-field>
      </form-section>
    </div>
    <div class=compliance-config-redflag-section__padding>
      <form-section form-title="'Non-Commensurate'">
        <div class="alert">
          <strong>Info: Updating/Deleting existing brackets will reset CIFs that are already tagged.</strong>
        </div>

        <compliance-customer-type-transaction-bracket-section
          config="\$ctrl.nonCommensurateConfig"
          red-flag-tag-type="'NON_COMMENSURATE'">
        </compliance-customer-type-transaction-bracket-section>
      </form-section>
    </div>

    <div class=compliance-config-redflag-section__padding>
      <form-section form-title="'Voluminous aggregate deposit'">
      <compliance-customer-type-transaction-bracket-section
          config="\$ctrl.voluminousAggregateTransactionConfig"
          red-flag-tag-type="'VOLUMINOUS_AGGREGATE_TRANSACTION'">
        </compliance-customer-type-transaction-bracket-section>
      </form-section>
    </div>
  </ng-form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/compliance-config-redflag-section.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;